<div class="chip-dropdown-wrapper">
  <mat-chip-list>
    <mat-chip
      color="accent"
      class="filter-chip"
      [selected]="!!selected"
      (click)="openDropdown()"
      (removed)="removed.emit()"
      [attr.aria-expanded]="dropdownOpen"
    >
      <ng-container chipLabel>
        <ng-container *ngIf="!!selected; else notSelected">
          {{ displayWith(selected) }}
          <button matChipRemove class="chip-clear-btn">
            <mat-icon>close</mat-icon>
          </button>
        </ng-container>
        <ng-template #notSelected> + {{ placeholder }} </ng-template>
      </ng-container>
    </mat-chip>
  </mat-chip-list>

  <div *ngIf="dropdownOpen">
    <div class="dropdown-backdrop" (click)="closeDropdown()"></div>
    <div
      class="filter-dropdown"
      #dropdownMenu
      (click)="$event.stopPropagation()"
    >
      <ng-content></ng-content>
    </div>
  </div>
</div>
